import { render, staticRenderFns } from "./page-layout-faqs-list.vue?vue&type=template&id=460b8b0d&scoped=true"
import script from "./page-layout-faqs-list.vue?vue&type=script&lang=js"
export * from "./page-layout-faqs-list.vue?vue&type=script&lang=js"
import style0 from "./page-layout-faqs-list.vue?vue&type=style&index=0&id=460b8b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460b8b0d",
  null
  
)

export default component.exports